import * as userRequest from "@/utils/userRequest";

export default async function updateAnnoucementService(
  idNoti: string,
  token: string,
  onSuccess?: (data?: any) => any,
  handleError?: (err?: any) => any
) {
  try {
    const res = await userRequest.patch(
      "helper/read-announce",
      {
        idNoti,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (res) {
      onSuccess && onSuccess(res);
      return res;
    }
  } catch (err) {
    console.error("🚀 ~ updateAnnoucementService ~ err:", err);
    handleError && handleError(err);
    throw err;
  }
}
